import React from 'react';
import clsx from 'clsx';
import { Link as RouterLink } from 'react-router-dom';
import {
  AppBar, Box, Toolbar, makeStyles, Typography, Tooltip,
} from '@material-ui/core';
import { THEMES } from 'src/constants';
import Notifications from 'src/views/shared/Notifications';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import TimelineIcon from '@material-ui/icons/Timeline';
import { useParams, useRouteMatch } from 'react-router';
import { Dashboard } from '@material-ui/icons';
import Account from './Account';
import WorkflowSelector from './WorkflowSelector';
import PerspectiveSelector from './PerspectiveSelector';

// @ts-ignore
const useStyles = makeStyles((theme) => ({
  root: {
    zIndex: theme.zIndex.drawer + 100,
    // @ts-ignore - name
    ...(theme.name === THEMES.LIGHT ? {
      boxShadow: 'none',
      backgroundColor: theme.palette.primary.main
    } : {}),
    // @ts-ignore - name
    ...(theme.name === THEMES.ONE_DARK ? {
      backgroundColor: theme.palette.background.default
    } : {})
  },
  toolbar: {
    minHeight: 64
  },
  logo: {
    // @ts-ignore - name
    color: theme.name === THEMES.LIGHT ? theme.palette.common.white : theme.palette.primary.main,
    fontFamily: 'Comfortaa !important',
    fontWeight: '800 !important',
    fontSize: '32px !important',
  },
  logoLink: {
    textDecoration: 'none'
  },
}));

type Props = {
    className?: string;
    onMobileNavOpen?: (...args: any[]) => any;
    workflowTab?: string,
    rootUrl?: string,
};

function TopBar({
  className, onMobileNavOpen, workflowTab, rootUrl, ...rest
}: Props) {
  const classes = useStyles();

  const { workflowId, perspectiveId } = useParams();

  const buttons = [
    {
      value: 'dashboard',
      to: `/workflows/${workflowId}/dashboard`,
      title: 'Go to workflow dashboard',
      icon: Dashboard
    },
    {
      value: 'process',
      to: `/workflows/${workflowId}/process`,
      title: 'Go to process editor',
      icon: TimelineIcon
    },
    {
      value: 'perspectives',
      to: `/workflows/${workflowId}/perspectives`,
      title: 'Go to perspective editor',
      icon: DesktopWindowsIcon
    },
  ];

  return (
    <AppBar className={clsx(classes.root, className)} {...rest}>
      <Toolbar className={classes.toolbar}>
        <Box display="flex" justifyContent="space-between" alignItems="center" flexGrow="1">
          <Box display="flex">
            <RouterLink to="/" className={classes.logoLink}>
              <Typography className={classes.logo}>
                flexbase
              </Typography>
            </RouterLink>
            {workflowTab && (
            <Box display="flex">
              <WorkflowSelector workflowId={workflowId} />
              {workflowTab === 'perspectives' && <PerspectiveSelector perspectiveId={perspectiveId} workflowId={workflowId} />}
            </Box>
            )}
          </Box>
          {workflowTab && (
          <Box display="flex" alignItems="center">
            <ToggleButtonGroup value={workflowTab} aria-label="text formatting" exclusive>
              {
                buttons.map(({
                  value, to, title, icon: Icon
                }) => (
                  <ToggleButton key={value} value={value} aria-label={value} component={RouterLink} to={to}>
                    <Tooltip title={title}>
                      <Icon />
                    </Tooltip>
                  </ToggleButton>
                ))
              }
            </ToggleButtonGroup>
          </Box>
          )}
          <Box display="flex" alignItems="center">
            <Notifications />
            <Box ml={2}>
              <Account />
            </Box>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  );
}
export default TopBar;
